import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { TemplateId } from 'modules/domains/template';
import {
  CampaignStateDefinition,
  GraphQLTypeNameData,
  GRAPHQL_TYPENAMES,
  MessageMedium,
  DraftStatus,
  GraphQLResponsePaginationInfo,
} from 'modules/graphql/types';
import { WorkflowType } from 'modules/workflows/enums';

type ListReferenceCommonData = {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
};

export type ListReferredByList = GraphQLTypeNameData<GRAPHQL_TYPENAMES.LIST> &
  ListReferenceCommonData & {
    creatorUserId: string;
  };

export type ListReferredByCampaign = GraphQLTypeNameData<GRAPHQL_TYPENAMES.CAMPAIGN> &
  ListReferenceCommonData & {
    createdBy: string;
    updatedBy: string | null;
    campaignState: CampaignStateDefinition;
    messageMedium: MessageMedium;
    templateId: TemplateId;
  };

export type ListReferredByJourney = GraphQLTypeNameData<GRAPHQL_TYPENAMES.JOURNEY> &
  ListReferenceCommonData & {
    creatorUserId: string;
    updatedByUserId: string | null;
    status: DraftStatus | null;
    enabled: boolean;
    isArchived: boolean;
    workflowType: WorkflowType;
  };

export type ListReference = ListReferredByList | ListReferredByCampaign | ListReferredByJourney;

export enum ListReferenceSortableProperty {
  id = 'Id',
  name = 'Name',
  type = 'ListDependentType',
  updatedAt = 'UpdatedAt',
  createdAt = 'CreatedAt',
}

export enum ListReferenceType {
  Campaign = 'Campaign',
  Journey = 'Journey',
  List = 'List',
}

export type ListReferenceFilterInfoInput = {
  listId: number;
  listDependentType?: ListReferenceType[];
};

export type ListReferencesQueryRequest = {
  filterInfo: ListReferenceFilterInfoInput;
  pagination?: {
    offset?: number;
    limit?: number;
  };
  sort?: {
    sortBy?: ListReferenceSortableProperty;
    sortDirection?: SORT_DIRECTIONS;
  };
  search?: string;
};

export type ListUsageQueryResponse = {
  findListUsage: {
    info: GraphQLResponsePaginationInfo;
    results: ListReference[];
  };
};

export type User = {
  id: string;
  fullName: string;
  avatarUrl?: string;
};

export type ModifierAndCreatorById = Record<User['id'], User>;
